import { render, staticRenderFns } from "./ClientProfiles.vue?vue&type=template&id=fa46b490"
import script from "./ClientProfiles.vue?vue&type=script&lang=js"
export * from "./ClientProfiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports